/**
 * 登录门禁：未登录弹登录/注册窗；已登录执行回调。
 * 用法：requireLogin(() => navigateTo(...)) / if (!requireLogin()) return
 */
export const useAuthGate = () => {
  const userStore = useUserStore()
  const { openLogin } = useAuthNav()

  const requireLogin = (onOk?: () => void): boolean => {
    if (userStore.isLoggedIn) {
      onOk?.()
      return true
    }
    openLogin()
    return false
  }

  return { requireLogin }
}
